import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-registro-mayotista',
  templateUrl: './registro-mayotista.component.html',
  styleUrls: ['./registro-mayotista.component.css',
    '../../assets/css/bootstrap.min.css',
    '../../assets/scss/styles.scss', 
    '../../assets/scss/registro.scss', 
    '../../assets/scss/fonts.scss',
    '../../assets/ema/main.scss', 
    ]
})
export class RegistroMayotistaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
